/* Room filter: filters product grid by data-rooms (collection handles).
 * Buttons in [data-room-filter]; data-room="" = All.
 * URL sync: ?room=handle or ?room=a,b (comma = match any).
 * Delegated events — survives theme AJAX re-renders. */
(function () {
  var PARAM = 'room';

  // Active filter: lowercase handles; empty = All
  var currentRooms = [];

  function grid() {
    return document.getElementById('main-collection-product-grid');
  }

  // ?room= -> array of handles
  function parseRoomsFromURL() {
    var raw = new URLSearchParams(window.location.search).get(PARAM);
    if (!raw) return [];
    return raw.split(',').map(function (r) { return r.trim().toLowerCase(); }).filter(Boolean);
  }

  // Write filter to URL without reload; All clears the param
  function writeRoomsToURL(rooms) {
    var url = new URL(window.location.href);
    if (rooms.length) url.searchParams.set(PARAM, rooms.join(','));
    else url.searchParams.delete(PARAM);
    window.history.replaceState({}, '', url.toString());
  }

  // Sync .is-active on buttons
  function updateButtons() {
    document.querySelectorAll('[data-room-filter] .room-filter-btn').forEach(function (btn) {
      var room = (btn.getAttribute('data-room') || '').toLowerCase();
      var active;
      if (!currentRooms.length) active = room === '';
      else if (currentRooms.length === 1) active = room === currentRooms[0];
      else active = room !== '' && currentRooms.indexOf(room) !== -1;
      btn.classList.toggle('is-active', active);
    });
  }

  // Show/hide grid items to match currentRooms
  function applyFilter() {
    var g = grid();
    if (!g) return;
    var visibleCount = 0;

    g.querySelectorAll('.product-grid__item[data-rooms]').forEach(function (item) {
      var rooms = (item.getAttribute('data-rooms') || '')
        .split('|')
        .map(function (r) { return r.trim().toLowerCase(); })
        .filter(Boolean);

      // Show if no filter, or product is in any selected room
      var match = !currentRooms.length || currentRooms.some(function (r) {
        return rooms.indexOf(r) !== -1;
      });

      item.style.display = match ? '' : 'none';
      if (match) visibleCount++;
    });

    // Hide tool/promo card while filtering
    g.querySelectorAll('[data-room-exempt]').forEach(function (el) {
      el.style.display = currentRooms.length ? 'none' : '';
    });

    // "No products" message when filter matches nothing
    var emptyMsg = g.querySelector('[data-room-empty]');
    if (emptyMsg) emptyMsg.hidden = visibleCount > 0;

    updateButtons();
  }

  // Clicks — delegated so re-rendered buttons still work
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-room-filter] .room-filter-btn');
    if (!btn) return;
    e.preventDefault();
    var room = (btn.getAttribute('data-room') || '').toLowerCase();
    currentRooms = room ? [room] : [];
    writeRoomsToURL(currentRooms);
    applyFilter();
  });

  // Back/forward buttons
  window.addEventListener('popstate', function () {
    currentRooms = parseRoomsFromURL();
    applyFilter();
  });

  // Re-apply filter if the theme swaps the grid via AJAX
  function watchGrid() {
    var g = grid();
    if (!g || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      if (currentRooms.length) applyFilter();
    }).observe(g.parentNode || g, { childList: true, subtree: true });
  }

  // Init: apply deep link, watch grid, re-apply after page settles
  function start() {
    currentRooms = parseRoomsFromURL();
    applyFilter();
    watchGrid();
    window.addEventListener('load', function () {
      setTimeout(applyFilter, 800);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();